var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import classnames from 'classnames';
import React from 'react';
import Icon from '../icon';
const RULES = {
    lg: 6,
    md: 4,
    sm: 4,
    xs: 4,
    xxs: 2,
};
function substring_rules(str = '', size = 'l', useRule) {
    if (!useRule) {
        return str;
    }
    let n = RULES[size];
    const reg = /.*[\u4e00-\u9fa5]+.*$/;
    let len = 0;
    let tmpStr = '';
    if (str.replace(/[\u4e00-\u9fa5]/g, '**').length <= n) {
        return str;
    }
    if (reg.test(str)) {
        for (var i = str.length - 1; i >= 0; i--) {
            if (/[\u4e00-\u9fa5]/.test(str[i])) {
                len += 2;
            }
            else {
                len += 1;
            }
            if (len > n) {
                break;
            }
            else {
                tmpStr = str[i] + tmpStr;
            }
        }
        return tmpStr;
    }
    for (var i = 0; i < str.length - 1; i++) {
        if (/[\u4e00-\u9fa5]/.test(str[i])) {
            len += 2;
        }
        else {
            len += 1;
        }
        if (len > n) {
            break;
        }
        else {
            tmpStr += str[i];
        }
    }
    return tmpStr;
}
;
export default class Avatar extends React.Component {
    constructor(props) {
        super(props);
        this.onLoadError = () => {
            if (this.props.onLoadError) {
                return this.props.onLoadError();
            }
            this.setState({
                loadError: true,
            });
        };
        this.state = {};
    }
    render() {
        let _a = this.props, { className, prefixCls, shape, size, children, src, icon, onClick, text, useRule = true, bgColor = '', style = {}, hangingurl, ishanging, hangingpos = 'bottom-right' } = _a, resetProps = __rest(_a, ["className", "prefixCls", "shape", "size", "children", "src", "icon", "onClick", "text", "useRule", "bgColor", "style", "hangingurl", "ishanging", "hangingpos"]);
        const { loadError } = this.state;
        //头像类名
        const avatarCls = classnames(prefixCls, className, `${prefixCls}-shape-${shape}`, {
            [`${prefixCls}-size-${size}`]: !!size,
        });
        let childText = text || children;
        //判断src是否存在,优先级高于children
        if (src) {
            childText = (<img src={src} onError={this.onLoadError}/>);
        }
        else if (icon) {
            childText = (<Icon type={icon} size={size}/>);
        }
        else {
            if (!React.isValidElement(childText)) {
                childText = substring_rules(childText, size, useRule);
            }
            if (bgColor) {
                style.backgroundColor = bgColor;
            }
        }
        if (loadError) {
            style.backgroundColor = bgColor;
            //if (!React.isValidElement(childText)) {
            childText = substring_rules(children, size, useRule);
            //}
        }
        let hangingWidth;
        if (size == 'xs') {
            hangingWidth = 24;
        }
        else if (size == 'md') {
            hangingWidth = 32;
        }
        else if (size == 'lg') {
            hangingWidth = 44;
        }
        // let pos = hangingpos.split('-');
        // let pos1 = pos[0];
        // let pos2 = pos[1];
        // const halfHangWidth = Number(hangingWidth)/2;
        let hangingStyle = {
            "width": hangingWidth + "px",
            "height": hangingWidth + "px",
        };
        return (<div>
        <div className={avatarCls} {...resetProps} style={style} onClick={onClick}>
          {childText}
        </div>
        {ishanging ? <img src={hangingurl} style={hangingStyle} className={classnames('hanging__icon', hangingpos)}/> : null}
      </div>);
    }
}
Avatar.defaultProps = {
    prefixCls: 'bs-avatar',
    size: 'md',
    shape: 'circle',
    children: '',
    useRule: true,
    bgColor: '',
};



// WEBPACK FOOTER //
// ./components/avatar/index.tsx